import { ajaxRequest } from "../../Utils/Ajax/ajax"
import { makeModal } from "../../Utils/utils"


export function loadCoursePage(){

    const courseId = $("#course-page").attr('data-kurs')

    $(".load-info-kurs").on("click", function(){
        loadCourseInfoModal(courseId, $(this))
    })


}

var loadCourseInfoModal = function (courseId, btn:boolean|JQuery = false) {

    const url = '/course/' + courseId.toString() + '/info'

    const success = function(data){
        const id = "kurs-info";
                const title = "Infos zu " + data.name;
                const content = '<div id="kurs-info-content">' + data.info + '</div>';
                const modal = makeModal(id, title, content, {}, true, 'xl');
                modal.show();
    }

    ajaxRequest(url, success, {}, btn);
}